import { ReactElement } from "react";
import Modify from "@shared/FormTemplates/Modify";
import ModifyForm from "./ModifyForm";
import updateItem from "@services/Clients/WhaleShark/glance/updateItem";
import useGetDetailItem from "@hooks/Clients/WhaleShark/glance/useGetGlance";
import validator from "@validators/Clients/WhaleShark/glance/Glance.validate";
import formMapper from "@mappers/Clients/WhaleShark/glance/glance.mapper";

const ModifyItem = (): ReactElement => (
  <Modify
    CustomForm={ModifyForm}
    modifyHook={updateItem}
    detailHook={useGetDetailItem}
    validator={validator}
    formMapper={formMapper}
  />
);

export default ModifyItem;
